export default class PromiseQueue {
    constructor() {
        this.queue = []
        this.workingOnPromise = false
        this.haltOnError = false
    }

    length() {
        return this.queue.length
    }

    enqueue(promise) {
        return new Promise((resolve, reject) => {
            this.queue.push({
                promise,
                resolve,
                reject,
            });
            this.dequeue();
        });
    }

    dequeue() {
        if (this.workingOnPromise) {
            return false;
        }

        const item = this.queue.shift();

        if (!item) {
            return false;
        }

        try {
            this.workingOnPromise = true;

            let promise = item.promise()

            if (!promise) {
                this.dequeue()
                return
            }

            promise.then((value) => {
                this.workingOnPromise = false;
                item.resolve(value);
                this.dequeue();
            })
            .catch(err => {
                this.workingOnPromise = false;
                item.reject(err);
                if (!this.haltOnError) {
                    this.dequeue();
                }
            })
        } catch (err) {
            this.workingOnPromise = false;
            item.reject(err);
            if (!this.haltOnError) {
                this.dequeue();
            }
        }
        return true;
    }
}